module.exports = __webpack_public_path__ + "img/plane-a319.c468bbc2.svg";